const state = () => ({
	username: localStorage.getItem('username'),
    groups: localStorage.getItem('groups'),
    access_token: localStorage.getItem('access_token'),
    refresh_token: localStorage.getItem('refresh_token'),
    user_id: localStorage.getItem('user_id'),
});

const getters = {
	check(state) {
        return state.username != null && state.access_token != null //&& state.refresh_token != null
    },
    username(state) {
        return state.username
    },
    groups(state) {
        return state.groups
    },
    refresh_token(state) {
        return state.refresh_token
    },
    access_token(state) {
        return state.access_token
    },
    user_id(state) {
        return state.user_id
    }
};
 
const actions = {
	logout(context) {
        context.commit('username', null);
        context.commit('groups', null);
        localStorage.removeItem('username');
        localStorage.removeItem('groups');
        context.commit('access_token', null);
        localStorage.removeItem('access_token');
        context.commit('refresh_token', null);
        localStorage.removeItem('refresh_token');
        context.commit('user_id', null);
        localStorage.removeItem('user_id');
        context.state.username = null;
        context.state.access_token = null;
        context.state.refresh_token = null;
        context.state.groups = null;
        context.state.user_id = null;
    },
    check: (context) => {
      return {}.hasOwnProperty.call(context.state.username, "username") &&
            {}.hasOwnProperty.call(context.state.groups, "groups") &&
            {}.hasOwnProperty.call(context.state.access_token, "access_token") &&
            {}.hasOwnProperty.call(context.state.refresh_token, "refresh_token")&&
            {}.hasOwnProperty.call(context.state.user_id, "user_id");;
    },
    'set-username'(context, username) {
        context.commit('username', username);
        localStorage.setItem('username', username);
    },
    'set-groups'(context, groups) {
        context.commit('groups', groups);
        localStorage.setItem('groups', groups);
    },
    'set-access-token'(context, access_token) {
        context.commit('access_token', access_token);
        localStorage.setItem('access_token', access_token);
    },
    'set-refresh-token'(context, refresh_token) {
        context.commit('refresh_token', refresh_token);
        localStorage.setItem('refresh_token', refresh_token);
    },
    'set-user-id'(context, user_id) {
        context.commit('user_id', user_id);
        localStorage.setItem('user_id', user_id);
    },
};
 
const mutations = {
	username(state, value) {
		state.username = value
	},
	groups(state, value) {
		state.groups = value
	},
	access_token(state, value) {
		state.access_token = value
	},
	refresh_token(state, value) {
		state.refresh_token = value
	},
    user_id(state, value) {
        state.user_id = value
    }
};
 
export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}